import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { FlaskConical, Pill, Microscope, Settings } from 'lucide-react';

export default function OurBusiness() {
  return (
    <div className="min-h-screen business-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-primary/5 via-background to-secondary/5 py-10 lg:py-10">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto text-center space-y-6">
            <Badge className="bg-primary/10 text-primary hover:bg-primary/20 border-primary/20">
              Our Business
            </Badge>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-foreground font-['Space_Grotesk'] leading-tight">
              Our Business
            </h1>
          </div>
        </div>
      </section>

      {/* Biosimilars Division */}
      <section className="py-10">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <Card className="card-glass border-purple-200/50 shadow-xl card-border-hover purple">
              <CardHeader>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-purple-500/10 to-pink-500/10 flex items-center justify-center icon-container">
                    <FlaskConical className="h-6 w-6 text-purple-600" />
                  </div>
                  <CardTitle className="text-2xl bg-gradient-to-r from-gray-800 to-purple-600 bg-clip-text text-transparent">
                    Biosimilars Division
                  </CardTitle>
                </div>
              </CardHeader>
              <CardContent className="space-y-6">
                <p className="text-lg text-gray-700 leading-relaxed">
                  Apken Biosimilars is the biosimilar division of Apken Pharma, focused on developing  safe, effective, and affordable alternatives to reference biologics.
                </p>
                
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">Focus Areas</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                      Oncology
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                      Autoimmune & Inflammatory Disorders
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                      Endocrinology
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                      Immunology
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">Capabilities</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                      Cell line development
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                      Analytical characterization
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                      Process development
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                      Clinical & regulatory support
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-purple-500 rounded-full mr-3"></span>
                      Pharmacovigilance
                    </li>
                  </ul>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Products & Pipeline */}
      <section className="py-10 bg-muted/30">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <Card className="card-hover card-gradient-primary border-blue-200/50 card-border-hover blue">
              <CardHeader>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-blue-500/10 to-purple-500/10 flex items-center justify-center icon-container">
                    <Pill className="h-6 w-6 text-blue-600" />
                  </div>
                  <CardTitle className="text-2xl bg-gradient-to-r from-gray-800 to-blue-600 bg-clip-text text-transparent">
                    Products & Pipeline
                  </CardTitle>
                </div>
              </CardHeader>
              <CardContent className="space-y-6">
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">Commercial Products</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                      Small-molecule generics
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                      Specialty formulations
                    </li>
                  </ul>
                </div>

                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">Biosimilars Pipeline</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                      Monoclonal antibodies
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                      Recombinant proteins
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-blue-500 rounded-full mr-3"></span>
                      Long-acting biologics
                    </li>
                  </ul>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Research & Development */}
      {/* <section className="py-10">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <Card className="card-hover card-gradient-accent border-green-200/50 card-border-hover green">
              <CardHeader>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-green-500/10 to-emerald-500/10 flex items-center justify-center icon-container">
                    <Microscope className="h-6 w-6 text-green-600" />
                  </div>
                  <CardTitle className="text-2xl bg-gradient-to-r from-gray-800 to-green-600 bg-clip-text text-transparent">
                    Research & Development
                  </CardTitle>
                </div>
              </CardHeader>
              <CardContent className="space-y-6">
                <p className="text-lg text-gray-700 leading-relaxed">
                  Our R&D strategy integrates advanced analytics, scalable manufacturing processes, and regulatory-aligned development pathways to ensure consistent quality and performance.
                </p>
                
                <div>
                  <h3 className="text-xl font-semibold text-gray-800 mb-4">R&D Highlights</h3>
                  <ul className="space-y-2 text-gray-700">
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                      Biosimilarity assessment
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                      Stability & comparability studies
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                      Process optimization
                    </li>
                    <li className="flex items-center">
                      <span className="w-2 h-2 bg-green-500 rounded-full mr-3"></span>
                      Technology transfer
                    </li>
                  </ul>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      </section> */}

      {/* Manufacturing */}
      {/* <section className="py-10 bg-muted/30">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <Card className="card-hover card-gradient-secondary border-purple-200/50 card-border-hover purple">
              <CardHeader>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-purple-500/10 to-pink-500/10 flex items-center justify-center icon-container">
                    <Settings className="h-6 w-6 text-purple-600" />
                  </div>
                  <CardTitle className="text-2xl bg-gradient-to-r from-gray-800 to-purple-600 bg-clip-text text-transparent">
                    Manufacturing
                  </CardTitle>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-lg text-gray-700 leading-relaxed">
                  Apken Pharma partners with WHO-GMP compliant manufacturing facilities equipped with modern infrastructure and validated processes to ensure product quality, safety, and consistency.
                </p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section> */}
    </div>
  );
}
